'use client';

import { useEffect } from 'react';

import Script from 'next/script';

type NextOptiDigitalServiceProps = { adUnit: string; deferMs?: number };

export const NextOptiDigitalConfig = ({
  adUnit,
  deferMs = 2000,
}: NextOptiDigitalServiceProps) => {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ENABLE_OPTI_DIGITAL !== 'true') {
      return undefined;
    }

    if (typeof window === 'undefined') {
      return undefined;
    }

    const injectOptiDigitalScript = () => {
      const existingScript = document.getElementById('optidigital-ad-init');
      if (!existingScript) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'optidigital-ad-init';
        script.async = true;
        script.src = '//scripts.opti-digital.com/tags/?site=scorenco';
        script.setAttribute('config', JSON.stringify({ adUnit }));
        document.head.appendChild(script);
        return;
      }

      // Le script est deja charge, on ne fait que rafraichir la zone associee.
      window.optidigitalQueue?.cmd?.push(() => {
        window.optidigitalToolbox?.infiniteScrollRefresh(adUnit);
      });
    };

    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(
        () => {
          injectOptiDigitalScript();
        },
        { timeout: deferMs }
      );
    } else {
      timeoutId = setTimeout(injectOptiDigitalScript, deferMs);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [adUnit, deferMs]);

  if (process.env.NEXT_PUBLIC_ENABLE_OPTI_DIGITAL !== 'true') {
    return null;
  }

  return (
    <Script
      id="opti-digital-queue-init"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
      var optidigitalQueue = optidigitalQueue || {};
      optidigitalQueue.cmd = optidigitalQueue.cmd || [];
      `,
      }}
    />
  );
};
